import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPrintersOffline } from "../../aplApi/printersHelper";
import { OfflinePrintersSearchProps } from "../../types/offlinePrintersSearchProps";
import { initialStateReprint } from "../defaultState";
import { getActiveLabels } from "../../aplApi/labelsHelper";
import { ReduxStateReprint } from "../../types/redux/reduxStateReprint";
import { stringContains } from "../../aplUtils/stringUtills";

export const getReprintLabelsRedux = createAsyncThunk("reprint/getReprintLabelsRedux", async () => {
    let response = await getActiveLabels();
    return response.data;
});

export const getReprintPrintersRedux = createAsyncThunk("reprint/getReprintPrintersRedux", async (props: OfflinePrintersSearchProps) => {
    let response = await getPrintersOffline(props);
    return response.data;
});

const reprint = createSlice({
    name: "reprint",
    initialState: initialStateReprint,
    reducers: {
        clearReprint: function (state) { return initialStateReprint },
        setReprintPrinterId: function (state, action) {
            return { ...state, selectedReprintPrinterId: action.payload } as ReduxStateReprint;
        },
        setReprintLabelId: function (state, action) {
            return { ...state, selectedReprintLabelId: action.payload };
        },
        setReprintCopies: function (state, action) {
            return { ...state, reprintCopies: action.payload };
        },
        setReprintCombinedPdf: (state, action) => ({ ...state, reprintCombinedPdf: action.payload }),
        setReprinted(state, action) {
            return { ...state, reprinted: action.payload };
        },
        addReprinted: (state, action) => ({ ...state, reprinted: [...state.reprinted, ...action.payload] }),
        setReprintingProgress(state, action) {
            return { ...state, reprintingProgress: action.payload };
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getReprintPrintersRedux.pending, state => {
                return {
                    ...state,
                    reprintPrintersLoading: true,
                    reprintPrintersErrorMessage: ""
                } as ReduxStateReprint;
            })
            .addCase(getReprintPrintersRedux.fulfilled, (state, action) => {
                return {
                    ...state,
                    reprintPrintersLoading: false,
                    reprintPrintersErrorMessage: "",
                    reprintPrinters: action.payload,
                    selectedreprintPrinterId: action.payload.find(x => stringContains(x.printerName, "pdftoprint"))?.printerId ?? action.payload.find(x => stringContains(x.printerName, "pdf"))?.printerId ?? action.payload[0].printerId
                } as ReduxStateReprint;
            })
            .addCase(getReprintPrintersRedux.rejected, (state, action) => {
                return {
                    ...state,
                    reprintPrintersLoading: false,
                    reprintPrintersErrorMessage: action.error.message ?? "API error",
                    reprintPrinters: []
                } as ReduxStateReprint;
            });

        builder
            .addCase(getReprintLabelsRedux.pending, state => {
                return {
                    ...state,
                    reprintLabelsLoading: true,
                    reprintLabelsErrorMessage: ""
                } as ReduxStateReprint;
            })
            .addCase(getReprintLabelsRedux.fulfilled, (state, action) => {
                return {
                    ...state,
                    reprintLabelsLoading: false,
                    reprintLabelsErrorMessage: "",
                    reprintLabels: action.payload
                } as ReduxStateReprint;
            })
            .addCase(getReprintLabelsRedux.rejected, (state, action) => {
                return {
                    ...state,
                    reprintLabelsLoading: false,
                    reprintLabelsErrorMessage: action.error.message ?? "API error",
                    reprintLabels: []
                } as ReduxStateReprint;
            });
    }
});

export const {
    clearReprint,
    setReprintCopies,
    setReprintLabelId,
    setReprintPrinterId,
    setReprintCombinedPdf,
    setReprinted,
    addReprinted,
    setReprintingProgress
} = reprint.actions;
export default reprint.reducer;
